RCA.client.Trueconf = (function () {

    var $templateTrueconfItem;

    /* ----- Init --------------------------------------------------------------------------------------------------- */
    function Init() {
        $templateTrueconfItem = $('template#tplTrueconfItem').contents(); // remove().
        Build();
    }

    function sort() {
        RCA.shared.AppData.trueconf.sort(function (a, b) {
            if (a.sort_id !== undefined && b.sort_id !== undefined) {
                return parseInt(a.sort_id) > parseInt(b.sort_id) ? 1 : -1;
            } else {
                return 0;
            }
        });
    }

    function Build() {
        var $fragment = $(document.createDocumentFragment()),
            $clone = $templateTrueconfItem.clone();

        sort();

        $.each(RCA.shared.AppData.trueconf, function (i, el) {
            if (el.visible != undefined && el.visible) {
                $clone = $templateTrueconfItem.clone();
                $clone.attr("data-id", el.id).attr("data-room", el.trueconf_room)
                $clone.find('.data-name').html(el.title[RCA.shared.AppData.settings.lang]);
                $clone.appendTo($fragment);
            }
        });
        $('#trueconf #trueconfList').html($fragment);
    }

    $(document).on('click', '#trueconfList .item', function (e) {
        showDetails($(this).attr("data-id"));
    });

    function showDetails(id) {
        if (id) {

            var tcroom;
            var server;
            var channel;
            let translator = false;

            if (id == "exhibitor") {
                tcroom = RCA.shared.AppData.profile.trueconf_room;
                server = 'exhibitor';

                if (RCA.shared.AppData.profile.group == "director" || RCA.shared.AppData.profile.group == "moderator") {
                    server = 'workshop';
                }

                if (RCA.shared.AppData.profile.group == "translator" && RCA.shared.AppData.modulsettings.translator_use_relay) {
                    translator = true;
                }
            } else {
                var trueconf_item = RCA.shared.AppData.trueconf.find(function (e) {
                    return e.id == id;
                });

                server = 'workshop';
                tcroom = trueconf_item.trueconf_room;
                channel = trueconf_item.channel;
            }
            if (translator) {
                if (RCA.client.trueconf_translator_opened) {
                    RCA.client.closeTrueConfCall("translator");
                } else {
                    RCA.client.closeTrueConfCall("translator");
                    RCA.client.openTrueConfCall(tcroom, server, channel,false, translator);
                }
            } else {
                if (RCA.client.trueconf_opened) {
                    RCA.client.closeTrueConfCall("default");
                } else {
                    RCA.client.closeTrueConfCall("default");
                    RCA.client.openTrueConfCall(tcroom, server, channel);
                }
            }

            /*if (RCA.client.trueconf_opened) {
                RCA.client.closeTrueConfCall();
                $(".mute-video-button").show().removeClass("animated fadeOut").addClass("animated fadeIn");
                $("#default_nav").find("[data-target='trueconf']").css("border", '');
            } else {
                RCA.client.closeTrueConfCall();
                RCA.client.openTrueConfCall(tcroom, server, false, translator);
                $("#default_nav").find("[data-targetid='" + id + "']").css("border", '2px solid ' + AppData.settings.colorIconBorder);
            }*/
        }
    }

    $(document).on('click', ".landing_elements .trueconf .translator_btn", function (){
        RCA.client.Layout.show("soundchannels");
    });

    $(document).on('click', ".landing_elements .trueconf .closetrueconf_btn", function (){
        RCA.client.closeTrueConfCall("default");
    });

    /* ----- Init --------------------------------------------------------------------------------------------------- */
    function BuildFromSource() {

        $.post('api/', {
            do: 'getTrueconf'
        }, function (data) {
            RCA.shared.AppData.trueconf = data;
            Init();
        });
    }

    function pushTcRoom(room) {
        RCA.client.closeTrueConfCall();
        RCA.client.openTrueConfCall(room, 'workshop');
    }

    function showTranslator() {
        if (RCA.shared.AppData.modulsettings.showtransbutton_trueconf) {
            $('#landing .landing_elements .trueconf .translator_btn').show();
        } else {
            $('#landing .landing_elements .trueconf .translator_btn').hide();
        }
    }

    /* ----- Public API --------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        BuildFromSource: BuildFromSource,
        BuildBroadcast: Build,
        showDetails: showDetails,
        showTranslator: showTranslator,
        pushTcRoom: pushTcRoom
    }
})();
